<template>
  <v-row align="center" justify="center">
    <v-col>
      <v-card>
        <highcharts v-if="userActions && userCompliance" :options="userActionsReport"></highcharts>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { USER_ACTIONS_QUERY, USER_COMPLIANCE_QUERY } from "@/graphql/queries/engagement.js";

export default {
  name: "UserEngagement",
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      userActions: null,
    };
  },
  computed: {
    userActionsReport() {
      var start = this.$moment().subtract(30, "days");
      var end = this.$moment();
      var engagementData = [];
      var complianceData = [];
      var days = [];
      var day = start;

      while (day <= end) {
        days.push(day.format("YYYY-MM-DD"));
        day = day.clone().add(1, "days");
      }

      engagementData = days.map((day) => {
        var action = this.userActions.edges.filter((val) => {
          return val.node.actionDate == day;
        });
        return [day, action[0] ? action[0].node.engagementRating : 0];
      });

      complianceData = days.map((day) => {
        var item = this.userCompliance.edges.filter((val) => {
          return val.node.complianceDate == day;
        });
        if (item[0]) {
          let total = 0;
          var workout = item[0].node.complianceitemSet.filter((val) => {
            return val.type == "WORKOUT" && val.label == "with_image";
          });

          total = workout[0] ? workout[0].counter : 0;

          var nutrition = item[0].node.complianceitemSet.filter((val) => {
            return val.type == "NUTRITION" && val.label == "with_image";
          });

          total += nutrition[0] ? nutrition[0].counter : 0;

          return [day, total];
        }
        return [day, 0];
      });

      var ctx = this;

      return {
        chart: {
          type: "line",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "User engagement and compliance",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: days,
        },
        yAxis: {
          title: {
            text: "Score",
          },
        },
        series: [
          {
            name: "User Engagement Score",
            data: engagementData,
            tooltip: {
              pointFormatter: function() {
                var plotValue = `Score: ${this.y} <br/>`;
                var action = ctx.userActions.edges.filter((val) => {
                  return val.node.actionDate == this.series.points[this.x]["name"];
                });
                if (action.length == 0) {
                  return plotValue;
                }

                action[0].node.actionSet.forEach((val) => {
                  plotValue = `${plotValue} ${val.type} ${val.label ? val.label : ""}: ${val.counter}<br/>`;
                });

                return plotValue;
              },
            },
          },
          {
            name: "User compliance Score",
            data: complianceData,
            tooltip: {
              pointFormatter: function() {
                var plotValue = `Score: ${this.y} <br/>`;
                var action = ctx.userCompliance.edges.filter((val) => {
                  return val.node.complianceDate == this.series.points[this.x]["name"];
                });
                if (action.length == 0) {
                  return plotValue;
                }

                action[0].node.complianceitemSet.forEach((val) => {
                  plotValue = `${plotValue} ${val.type} ${val.label ? val.label : ""}: ${val.counter}<br/>`;
                });

                return plotValue;
              },
            },
          },
        ],
      };
    },
  },
  apollo: {
    userActions: {
      query: USER_ACTIONS_QUERY,
      variables() {
        return {
          userId: btoa("UserNode:" + this.userId),
          startDate: this.$moment()
            .subtract(30, "days")
            .format("YYYY-MM-DD"),
        };
      },
      fetchPolicy: "cache-and-network",
    },
    userCompliance: {
      query: USER_COMPLIANCE_QUERY,
      variables() {
        return {
          userId: btoa("UserNode:" + this.userId),
          startDate: this.$moment()
            .subtract(30, "days")
            .format("YYYY-MM-DD"),
        };
      },
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>
